import styled from "@emotion/styled";
import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import Theme from "../../Themes/main.theme";
import { ITabsLayout, StyledTabProps } from "./type";

const AntTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: Theme?.labelColor?.main,
  },
});

const StyledTab = styled((props: StyledTabProps) => <Tab {...props} />)(() => ({
  textTransform: "none",
  "&.Mui-selected": {
    color: Theme?.labelColor?.main,
  },
}));

const TabsLayout = ({
  tabLabels,
  tabContent,
  tab,
  setTab,
  deleteSearchParams = false,
  resetFilters, // used as generic on Tab Change function
  scrollable = false,
}: ITabsLayout) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    if (deleteSearchParams) {
      [...searchParams].map((param) => {
        searchParams.delete(param[0]);
        setSearchParams(searchParams);
      });
    }
    if (resetFilters) {
      resetFilters();
    }
    setTab(newValue);
  };

  return (
    <>
      <AntTabs
        value={tab}
        onChange={handleChangeTab}
        aria-label='icon position tabs'
        {...(scrollable && {
          variant: "scrollable",
          scrollButtons: true,
          allowScrollButtonsMobile: true,
        })}
      >
        {tabLabels.map((tab, index) => {
          return (
            <StyledTab
              key={index}
              icon={tab.icon
                ? tab.icon
                : undefined}
              iconPosition={"bottom"}
              label={tab.label}
            />
          );
        })}
      </AntTabs>
      <Box>{tabContent[tab]}</Box>
    </>
  );
};

export default TabsLayout;
